import React from 'react'
import styles from './ImagePortrait.module.scss'
import cl from 'classnames'
import { ImagePortraitProps } from './ImagePortrait.types'
import { IconImage } from 'assets'
import { getImageInfo } from './ImagePortrait.utils'

const ImagePortraitComponent = (props: ImagePortraitProps) => {
  const {
    width = 23.8,
    className,
    alt,
    src,
    saveOriginalDimensions,
    ...rest
  } = props

  const handleImageInfo = () => {
    const img = getImageInfo(src)
    saveOriginalDimensions && saveOriginalDimensions(img.naturalWidth, img.naturalHeight)
  }

  if (!src) {
    return (
      <div
        className={cl(styles.imagePortrait, styles.noImageContainer, className)}
        style={{
          width,
          height: width / 0.7
        }}
      >
        <IconImage />
      </div>
    )
  }

  return (
    <img
      className={cl(styles.imagePortrait, className)}
      width={width}
      height={width / 0.7}
      alt={alt}
      src={src}
      onLoad={handleImageInfo}
      {...rest}
    />
  )
}

const ImagePortrait = ImagePortraitComponent
export { ImagePortrait }
